module.exports = __webpack_public_path__ + "20715aa16642805a5214a574eae5cb14.jpg";